<app-dashboard-header></app-dashboard-header>

<main>
  <div class="container">
    <h2 class="mt-5">الاقســـــــام</h2>
    <table class="table table-bordered table-hover mt-5 mb-5">
      <thead class="thead-dark">
        <tr>
          <th>رقــم التسلسل</th>
          <th>اســم القســـم</th>
          <th>الصورة</th>
          <th>الوصـــف</th>
          <th>العمليــات</th>
        </tr>
      </thead>
      <tbody>
        <!-- routerLink="/getCategoryById/{{category._id}}" -->
        <tr *ngFor="let category of categories; let i = index" style="cursor: pointer;">
          <td>{{ category._id }}</td>
          <td>{{ category.Title }}</td>
          <td>
            <img
              src="https://khairokom-uploadfiles.azurewebsites.net/files/{{category.Image}}"
              width="100px"
              height="auto"
              alt="تحميل الصورة"
            />
          </td>
          <td>{{ category.Description }}</td>
          <td>
            <a class="update btn btn-light" routerLink="/updateCategory/{{category._id}}">التعـــديل</a>
            <a class="delete btn btn-secondary" (click)="delete(category._id)">الحـــذف</a>
            
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</main>

<app-dashboard-footer></app-dashboard-footer>
